import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import Slider from '@mui/material/Slider';
import { FaFilter } from "react-icons/fa";
import { useProductStore } from '../store/useProductStore';
import Loader from './Loader/Loader';


function valuetext(value) {
  return `${value}°C`;
}

const PriceFilterCard = () => {

  const [value, setValue] = React.useState([0, 0]);
  const [minmaxValue, setMinmaxValue] = React.useState([0, 0]);
  const [category, setCategory] = React.useState([]);

  const handleChange = (event, newValue) => {
    setSelectedCategoryId('')
    setValue(newValue);
    console.log(newValue)
  };

  const { getPriceRange, loading, getCategoryInPriceRange, categoryInPriceRange } = useProductStore()

  const [selectedCategoryId, setSelectedCategoryId] = React.useState('');

  const handleCheckboxChange = (id) => {
    setSelectedCategoryId(prev => (prev === id ? '' : id));
  };

  const getPriceRangeFunction = async () => {
    const data = await getPriceRange() || []
    if (
      data[0]?.maxRetailPrice != null &&
      data[0]?.minRetailPrice != null
    ) {
      setValue([data[0].minRetailPrice, data[0].maxRetailPrice]);
      setMinmaxValue([data[0].minRetailPrice, data[0].maxRetailPrice]);
    }

  }

  React.useEffect(() => {
    getPriceRangeFunction()
  }, [])

  const getFilteredProductFunction = async () => {
    const ref = await getCategoryInPriceRange(value[0], value[1], selectedCategoryId)
    setCategory(ref)
  }

  React.useEffect(() => {
    getFilteredProductFunction()
  }, [value])

  return (

    <Box sx={{
      width: '100%',
      backgroundColor: "#fff",
      borderRadius: '15px',
      border: '1px solid #ECECEC',
      boxShadow: '5px 5px 15px 0px #0000000D',
      '& .filterInner': {
        padding: '25px',
      }
    }}>
      <Loader loading={loading} />
      <div className="filterInner">
        <Typography sx={{
          fontSize: '24px',
          lineHeight: '28.8px',
          fontWeight: '700',
          fontFamily: `"Quicksand", sans-serif`,
          color: '#253D4E',
          paddingBottom: '16px',
          borderBottom: '1px solid #ECECEC',
          position: 'relative',
          '&::before': {
            content: `""`,
            width: '80px',
            height: '2px',
            background: '#008BFF',
            position: 'absolute',
            left: '0',
            bottom: '0',
          },
        }}>Fill by price</Typography>
        <Box sx={{ width: '100%', margin: '15px 0 0' }}>
          <Slider
            min={minmaxValue[0]}
            max={minmaxValue[1]}
            value={value}
            onChange={handleChange}
            valueLabelDisplay="auto"
          />

          <Typography sx={{
            fontSize: '14px',
            lineHeight: '24px',
            fontWeight: '600',
            fontFamily: `"Lato", sans-serif`,
            color: '#687188',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px',
            '& span span': {
              fontWeight: '400',
              color: '#008BFF',
            },
          }}>
            <span>From: <span>${value[0]}</span></span>
            <span>To: <span>${value[1]}</span></span>
          </Typography>
          <Typography sx={{
            fontSize: '14px',
            lineHeight: '24px',
            fontWeight: '900',
            fontFamily: `"Lato", sans-serif`,
            color: '#7E7E7E',
          }}>Categories</Typography>
          <FormGroup sx={{
            '& label': {
              color: '#687188',
              fontSize: '14px',
              lineHeight: '24px',
              fontWeight: '400',
              fontFamily: `"Lato", sans-serif`,
            },
            '& label svg': {
              fill: '#CED4DA',
            },
          }}>
            {(categoryInPriceRange || []).map((ele, index) => (
              <FormControlLabel
                key={ele._id}
                control={
                  <Checkbox
                    checked={selectedCategoryId === ele?.categoryId}
                    onChange={() => handleCheckboxChange(ele?.categoryId)}
                  />
                }
                label={`${ele?.categoryName} (${ele?.productCount})`}
              />
            ))}
          </FormGroup>
          <Button sx={{
            width: '106px',
            height: '40px',
            borderRadius: '4px',
            backgroundColor: '#2B3463',
            color: '#fff',
            fontSize: '12px',
            lineHeight: '21.6px',
            letterSpacing: '0.5px',
            fontWeight: '700',
            fontFamily: `"Quicksand", sans-serif`,
            textTransform: 'capitalize',
            marginTop: '20px',
            '& svg': {
              marginRight: '10px',
            },
          }}
            onClick={() => getFilteredProductFunction()}>
            <FaFilter />   Filter
          </Button>
        </Box>
      </div>
    </Box>
  );
}

export default PriceFilterCard;